import React from 'react';
import IPortfolioDetailsPage from './IPortfolioDetailsPage';
import Header from '@appComponents/Header/Header';
import WhitePaper from '@appComponents/WhitePaper/WhitePaper';
import * as style from './PortfolioDetailsPageStyle.module.scss'

export default class PortfolioDetailsPage extends React.Component<IPortfolioDetailsPage> {

  render() {
    return (
      <>
        <Header padding={'50 20'}>Portfolio Details Page</Header>
        <div className={style.portfolioDetailsPage}>
          <WhitePaper>
            Hello to portfolio details
          </WhitePaper>
        </div>
      </>
    );
  }
}
